export const ApplicationEnum = {
    ANDROID : "اندروید کاربر",
    IOS:"آی او اس کاربر",
    WEBPANEL:"پنل ادمین",
    WEBAPP:"وب اپلیکیشن کاربر",
    WEBMASTER:"اپلیکیشن مراکز",
    WEBCORPORATE:"اپلیکیشن سازمان"
}
